"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePassword = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _actions = require("../../actions");
var initialState = {
  loading: false
};
var updatePassword = (0, _toolkit.createReducer)(initialState, function (builder) {
  builder.addCase(_actions.updatePasswordAction.pending, function (state) {
    state.loading = true;
  });
  builder.addCase(_actions.updatePasswordAction.rejected, function (state) {
    state.loading = false;
  });
  builder.addCase(_actions.updatePasswordAction.fulfilled, function (state) {
    state.loading = false;
    state.done = true;
  });
});
exports.updatePassword = updatePassword;